import { Component, OnInit } from '@angular/core';
import { AppconfigService } from '../service/appconfig.service';

@Component({
  selector: 'app-cookiepolicy',
  templateUrl: './cookiepolicy.component.html',
  styleUrls: ['./cookiepolicy.component.scss']
})
export class CookiepolicyComponent implements OnInit {

  constructor(private configService: AppconfigService) { }

  cookieCat = this.configService.config.cookie_server;

  ngOnInit(): void {
    console.log("inside cookiepolicy")
  }

}
